import React, { Fragment } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { RouteComponentProps, withRouter } from 'react-router';
import { ContactUsUrl, FuelPumpInfoPage, HomeUrl } from '../../constants/url';
import { getOfficialAssetUrl } from '../../utils/resource';
import './index.scss';
import Container from '../container';
import { ContactUsScrollType } from '../../constants/contactUsScrollType';
import {
  AboutAutobestLinkOptions,
  CatalogLinkOptions,
  FuelPumpInfoLinkOptions1,
  FuelPumpInfoLinkOptions2,
  FuelPumpInfoLinkOptions3,
  FuelPumpInfoLinkOptions4,
  FuelPumpsBarItemTextList,
  PerformancePumpsBarItemTextList,
  UniversalPumpsBarItemTextList
} from './constants';
import BarItem from './BarItem';

interface FooterState {
  visibleNames: { [propsName: string]: boolean };
  barTitleVisible: boolean;
}

class Footer extends React.Component<RouteComponentProps, FooterState> {
  readonly prefixCls = 'footer';

  constructor(props) {
    super(props);

    this.state = {
      visibleNames: {},
      barTitleVisible: this.getBarTitleVisible()
    };
  }

  componentDidUpdate(prevProps: Readonly<RouteComponentProps>) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      const barTitleVisible = this.getBarTitleVisible();
      if (barTitleVisible !== this.state.barTitleVisible) {
        this.setState({ barTitleVisible });
      }
    }
  }

  getBarTitleVisible = () => this.props.location.pathname !== HomeUrl;

  onVisibleChange = name => {
    this.setState(prevState => ({
      visibleNames: {
        ...prevState.visibleNames,
        [name]: !prevState.visibleNames[name]
      }
    }));
  };

  renderLink = linkOptions => (
    <div className={`${this.prefixCls}-link-content`}>
      {linkOptions.map(item => (
        <Link key={item.name} to={item.url}>
          {item.name}
        </Link>
      ))}
    </div>
  );

  renderCollapse = (title, children) => {
    const cls = this.prefixCls;
    const { visibleNames } = this.state;

    return (
      <Fragment>
        <div
          className={classNames(`${cls}-title`, {
            [`${cls}-visible`]: visibleNames[title]
          })}
          onClick={() => this.onVisibleChange(title)}
        >
          {title}
        </div>
        <div
          className={classNames(`${cls}-collapse-content`, {
            [`${cls}-visible`]: visibleNames[title]
          })}
        >
          {children}
        </div>
      </Fragment>
    );
  };

  renderFuelPumpInfo = () => {
    const cls = this.prefixCls;

    return (
      <div className={`${cls}-fuel-content`}>
        {this.renderLink(FuelPumpInfoLinkOptions1)}
        {this.renderLink(FuelPumpInfoLinkOptions2)}
        {this.renderLink(FuelPumpInfoLinkOptions3)}
        {this.renderLink(FuelPumpInfoLinkOptions4)}
      </div>
    );
  };

  renderContact = () => {
    const cls = this.prefixCls;

    return (
      <ul
        className={`${cls}-contact-content flex-row col-top row-between flex-wrap`}
      >
        <li>
          <img src={getOfficialAssetUrl('/default/footer-location_u16.png')} />
          <div>
            2500 Troy Ave.
            <br />
            South El Monte, CA
            <br />
            91733
          </div>
        </li>
        <li>
          <img
            src={getOfficialAssetUrl('/default/footer-technical_u21.png')}
            alt=""
          />
          <div>
            <Link
              className={`${cls}-link`}
              to={`${ContactUsUrl}?point=${ContactUsScrollType.TechnicalSupport}`}
            >
              Technical Support
            </Link>
            <br />
            <Link
              className={`${cls}-link`}
              to={`${ContactUsUrl}?point=${ContactUsScrollType.CustomerService}`}
            >
              Customer Service
            </Link>
          </div>
        </li>
        <li>
          <img src={getOfficialAssetUrl('/default/footer-phone_u17.png')} />
          <div>800-773-6088</div>
        </li>
        <li>
          <img src={getOfficialAssetUrl('/default/footer-inquiries_u22.png')} />
          <div>
            <Link
              className={`${cls}-link`}
              to={`${ContactUsUrl}?point=${ContactUsScrollType.SalesInquiries}`}
            >
              Sales Inquiries
            </Link>
            <br />
            <Link
              className={`${cls}-link`}
              to={`${ContactUsUrl}?point=${ContactUsScrollType.MediaInquiries}`}
            >
              Media Inquiries
            </Link>
          </div>
        </li>
      </ul>
    );
  };

  renderFollow = () => {
    const cls = this.prefixCls;

    return (
      <div className={`${cls}-follow`}>
        <div className={`${cls}-follow-title`}>Follow Us</div>
        <div className={`${cls}-follow-content flex-row row-between`}>
          <Link
            to={{
              pathname: 'https://www.facebook.com/profile.php?id=61558093737372'
            }}
            target="_blank"
          >
            <img src={getOfficialAssetUrl('/default/facebook.png')} />
          </Link>
          <Link
            to={{
              pathname:
                'https://www.linkedin.com/company/autobest-international/?viewAsMember=true'
            }}
            target="_blank"
          >
            <img src={getOfficialAssetUrl('/default/linkin.png')} />
          </Link>
          <Link
            to={{
              pathname: 'https://www.youtube.com/@AutobestUSA'
            }}
            target="_blank"
          >
            <img src={getOfficialAssetUrl('/default/youtube.png')} />
          </Link>
        </div>
      </div>
    );
  };

  renderBar = () => {
    const cls = this.prefixCls;
    const { barTitleVisible } = this.state;

    return (
      <div
        className={classNames(`${cls}-bar`, {
          [`${cls}-home`]: !barTitleVisible
        })}
        style={{
          // @ts-ignore
          '--footer-bar-bg': `url(${getOfficialAssetUrl(
            '/default/u83_state0.jpg'
          )})`
        }}
      >
        <Container>
          {barTitleVisible ? (
            <div className={`${cls}-bar-title font-hyperspace`}>
              Autobest Fuel Pump Line
            </div>
          ) : null}
          <div className={`${cls}-bar-content`}>
            <BarItem
              prefixCls={`${cls}-bar-item`}
              title="OE Replacement Fuel Pumps"
              textList={FuelPumpsBarItemTextList}
              url={FuelPumpInfoPage.Electric}
              img={getOfficialAssetUrl('/default/u92.svg')}
            />
            <BarItem
              prefixCls={`${cls}-bar-item`}
              title="Upgraded High-Performance Pumps"
              textList={PerformancePumpsBarItemTextList}
              url={FuelPumpInfoPage.HighPerformance}
              img={getOfficialAssetUrl('/default/u95.svg')}
            />
            <BarItem
              prefixCls={`${cls}-bar-item`}
              title="Universal Pumps"
              textList={UniversalPumpsBarItemTextList}
              url={FuelPumpInfoPage.UniversalTransfer}
              img={getOfficialAssetUrl('/default/u106.svg')}
            />
          </div>
        </Container>
      </div>
    );
  };

  render() {
    const cls = this.prefixCls;
    return (
      <footer className={cls}>
        {this.renderBar()}
        <div className={`${cls}-content`}>
          <div className={`${cls}-top flex-row`}>
            <div className={`${cls}-about`}>
              {this.renderCollapse(
                'About Autobest',
                this.renderLink(AboutAutobestLinkOptions)
              )}
              {this.renderCollapse(
                'Catalog',
                this.renderLink(CatalogLinkOptions)
              )}
            </div>
            <div className={`${cls}-fuel`}>
              {this.renderCollapse('Fuel Pump Info', this.renderFuelPumpInfo())}
            </div>
            <div className={`${cls}-contact`}>
              {this.renderCollapse('Contact Us', this.renderContact())}
            </div>
            {this.renderFollow()}
          </div>
          <div className={`${cls}-bottom flex-col col-center`}>
            <div>Copyright © 2024/2025 Autobest - All rights reserved.</div>
            <img
              className={`${cls}-logo`}
              src={getOfficialAssetUrl('/default/footer-logo_u10.png')}
            />
          </div>
        </div>
      </footer>
    );
  }
}

export default withRouter(Footer);
